<div class="row" [formGroup]="formEntryForm">
    <ng-container formArrayName="fields">
        <ng-container *ngFor="let field of fields.controls; let i = index">
            <ng-container [formGroup]="field">
                <mat-form-field appearance="outline" class="w-100 mb-3">
                    <mat-label>Field name</mat-label>
                    <mat-error>You need to enter a field name</mat-error>
                    <input matInput placeholder="Ex: firstName" formControlName="fieldName" required>
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="onRemoveField(i)">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-hint>Enter the field name</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mb-3">
                    <mat-label>Field Description</mat-label>
                    <mat-error>You need to enter a field description</mat-error>
                    <input matInput placeholder="Ex: gather the user's first name" formControlName="fieldDescription" required>
                    <mat-hint>Enter a description of that field</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mb-3">
                    <mat-label>Field key</mat-label>
                    <mat-error>You need to enter a field key</mat-error>
                    <input matInput placeholder="Ex: first_name" formControlName="fieldKey" required>
                    <mat-hint>Enter the exact field key used in your zap</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100 mb-3">
                    <mat-label>
                        Select a data type
                    </mat-label>
                    <mat-select formControlName="fieldType">
                        <mat-option *ngFor="let type of dataTypes" class="mx-auto" [value]="type">
                            {{type}}
                        </mat-option>
                    </mat-select>
                    <mat-error>You need to select a data type</mat-error>
                    <mat-hint align="start">Boolean means a true or false value</mat-hint>
                </mat-form-field>
            </ng-container>
        </ng-container>
    </ng-container>
</div>


<div class="col-12 d-flex justify-content-center">
    <button type="button" (click)="onAddField()" mat-fab class="bg-light text-dark me-2"
        aria-label="Example icon button with a delete icon">
        <mat-icon>add</mat-icon>
    </button>
</div>